import ModalsView from './modals_view';
export default ModalsView;
